(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){

module.exports = Vue.component('enabler',{
    props:['label','value', 'onChange'],
    data: function(){
        return {
            
        }
    },
    methods:{
        
    },
    template:
     `<div class="vue-enabler">
        <div class="option">
            <p><b><label>{{label}}</label></b></p>
            <p>
                <select class="regular-text" name="enabled" v-model="value" @change="$emit('change',value);">
                    <option value="enabled">Enabled</option>
                    <option value="disabled">Disabled</option>
                </select>
            </p>
        </div>
     </div>`
 });
 
}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/vue/components/enabler.js","/vue/components")